import { render, staticRenderFns } from "./RecentDocumentsItems.vue?vue&type=template&id=b339f4e6"
import script from "./RecentDocumentsItems.vue?vue&type=script&lang=ts"
export * from "./RecentDocumentsItems.vue?vue&type=script&lang=ts"
import style0 from "./RecentDocumentsItems.vue?vue&type=style&index=0&id=b339f4e6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports